import { create } from 'zustand';

import AppConfig from '../config/AppConfig';
import BackEndConnection from '../dal/BackEndConnection';

const ServerSettingsStore = create((set) => {
    let _ServerSettingsStore = {
        serverSettings: null,
    };

    _ServerSettingsStore.updateAttribute = (attributeName, newValue) => {
        set((state) => {
            state.serverSettings[attributeName] = newValue;
            return { serverSettings: state.serverSettings };
        });
    };

    _ServerSettingsStore.load = (successCallback, errorCallback) => {
        const payload = {};
        const url = AppConfig.HOST_URL + 'serverSettings/load';

        return BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({ serverSettings: data }));
            },
            successCallback,
            errorCallback,
        );
    };

    _ServerSettingsStore.save = (data, successCallback, errorCallback) => {
        const payload = data;
        var url = AppConfig.HOST_URL + 'serverSettings/update';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    };

    return _ServerSettingsStore;
});

export default ServerSettingsStore;
